import { type FC, useContext, useId, useState } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import { IconInfo } from '@redteclab/icons'

import { FormControl, FormHelperText, FormLabel, Input, Tooltip } from 'base-ui'

import { LoginRegistrationRegistrationFormStateContext } from '../../context/LoginRegistrationRegistrationFormStateContext'

export const DEFAULT_COUNTRY_CODE_COM = '+49'

export const LoginRegistrationRegistrationFormPhoneWithInfo: FC = () => {
  const intl = useIntl()
  const { registrationFormState } = useContext(
    LoginRegistrationRegistrationFormStateContext,
  )
  const { model } = registrationFormState
  registrationFormState.use()

  const phoneInputId = useId()
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null)

  const handleFocus = (): void => {
    if (!model.phone || model.phone.length === 0) {
      registrationFormState.setValue(DEFAULT_COUNTRY_CODE_COM, model, 'phone')
    }
  }

  return (
    <FormControl
      error={!model.validator.isPropertyValid('phone')}
      onFocus={handleFocus}
      value={model.phone}
    >
      <FormLabel htmlFor={phoneInputId}>
        {intl.formatMessage({ id: 'general.form.label.phone' })}
      </FormLabel>
      <Input
        {...registrationFormState.makeInputProps('phone')}
        endAdornment={
          <Tooltip
            anchor={anchorEl}
            arrow
            className="w-full"
            clickTrigger
            disablePortal
            id="toop-tip-phone"
            placement="top"
            title={<FormattedMessage id="registration.phone.info" />}
          >
            <IconInfo className="size-6 text-dark-brand" />
          </Tooltip>
        }
        ref={setAnchorEl}
        slotProps={{
          input: {
            'data-qa-id': 'register-form-phone',
            id: phoneInputId,
          },
        }}
      />
      {model.validator.getFirstErrorFor('phone') && (
        <FormHelperText>
          {model.validator.getFirstErrorFor('phone')}
        </FormHelperText>
      )}
    </FormControl>
  )
}
